// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__qbBg4","insightsList":"newBusinessInsightsMenu_insightsList__3-HQQ","active":"newBusinessInsightsMenu_active__31am4"};